import axios from 'axios'
import resolveEndpoint from './resolveEndpoint'
import fixQuery from './fixQuery'
import token from './token'


const createRequest = (opts) => {
  const {
    method, endpoint, query, body,
    timeout, tokenName, cancelToken,
    fixQuery: needToFixQuery, sameOrigin: withCredentials, formData: isFormData,
  } = opts

  const url = resolveEndpoint(endpoint)
  const params = needToFixQuery ? fixQuery(query) : query

  const headers = {
    'Content-Type': isFormData ? 'application/x-www-form-urlencoded; charset=UTF-8' : 'application/json',
    'Accept': 'application/json',
    ...(opts.headers || {}),
  }

  let data = opts.data || body

  if (tokenName) {
    data = data || {}
    data.token = token.get(tokenName)
  }

  if (isFormData) {
    data = Object.keys(data).reduce((formData, key) => {
      formData.append(key, data[key])

      return formData
    }, new FormData())
  }

  return axios({
    url,
    headers,
    method,
    params,
    data,
    withCredentials,
    cancelToken,
    timeout: timeout || 60000,
  })
}


export default createRequest
